import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "bg-secondary"
}
const _hoisted_2 = { class: "container py-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-3 dog text-center" }, "Doggie App", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-center my-3 fs-4 fw-bold dog"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_breed = _resolveComponent("input-breed")!
  const _component_loader = _resolveComponent("loader")!
  const _component_dog_image = _resolveComponent("dog-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_input_breed),
      (_ctx.noBreedFound)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "No breed found"))
        : (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_loader, { key: 1 }))
          : (_openBlock(), _createBlock(_component_dog_image, { key: 2 }))
    ])
  ]))
}